const GC = window.__GENERATED_CONSTANTS__

export const TaskFieldFilterKey = {
    STATUS: 'STATUS'
}

export const TaskSortBy = {
    CUSTOMER: GC.TaskSortBy.CUSTOMER,
    PROJECT: GC.TaskSortBy.PROJECT,
    TASK: GC.TaskSortBy.TASK,
    STATUS: GC.TaskSortBy.STATUS,
    WORKFLOW_STATUS: GC.TaskSortBy.WORKFLOW_STATUS,
    DEADLINE: GC.TaskSortBy.DEADLINE,
    ESTIMATE: GC.TaskSortBy.ESTIMATE,
    LAST_TRACKING_DATE: GC.TaskSortBy.LAST_TRACKING_DATE,
    TYPE_OF_WORK: GC.TaskSortBy.TYPE_OF_WORK,
    CREATION_DATE: GC.TaskSortBy.CREATION_DATE,
    SPENT_TIME: GC.TaskSortBy.SPENT_TIME,
    VARIANCE_MAN_HOURS: "VARIANCE_MAN_HOURS",
    VARIANCE_PERCENTS: "VARIANCE_PERCENTS",
    VARIANCE_PROGRESS_BAR: "VARIANCE_PROGRESS_BAR",
}

export const TaskTableDefaultSorting = {by: TaskSortBy.TASK, asc: true}

export const TaskManagementViewMode = {
    TABLE: 'TABLE',
    KANBAN: 'KANBAN'
}

export const TableTasksConstants = {
    OPEN_TASK_EXISTS_ERROR: GC.TableTasksConstants.OPEN_TASK_EXISTS_ERROR,
    COMPLETED_TASK_EXISTS_ERROR: GC.TableTasksConstants.COMPLETED_TASK_EXISTS_ERROR,
    UNKNOWN_TASK_EXISTS_ERROR: GC.TableTasksConstants.UNKNOWN_TASK_EXISTS_ERROR,
    BILLING_TYPE_DELETED_OR_ARCHIVED_ERROR: GC.TableTasksConstants.BILLING_TYPE_DELETED_OR_ARCHIVED_ERROR,
}

export const TaskListStaticFilters = [{
    key: TaskFieldFilterKey.STATUS,
    title: 'Status'
}]

export const TaskTableConfigurableColumns = {
    DEADLINE: GC.TaskSortBy.DEADLINE,
    ESTIMATE: GC.TaskSortBy.ESTIMATE,
    LAST_TRACKING_DATE: GC.TaskSortBy.LAST_TRACKING_DATE,
    TYPE_OF_WORK: GC.TaskSortBy.TYPE_OF_WORK,
    CREATION_DATE: GC.TaskSortBy.CREATION_DATE,
    SPENT_TIME: GC.TaskSortBy.SPENT_TIME,
    VARIANCE_MAN_HOURS: TaskSortBy.VARIANCE_MAN_HOURS,
    VARIANCE_PERCENTS: TaskSortBy.VARIANCE_PERCENTS,
    VARIANCE_PROGRESS_BAR: TaskSortBy.VARIANCE_PROGRESS_BAR,
}

export const TASK_LOAD_LIMIT = 20

export const PRIORITY_FIELD_NAME = 'priority'



// WEBPACK FOOTER //
// ./web/js/taskManagement/constants.js